import { FC, ReactNode } from 'react';

export const ContainerHeaderTemplate: FC<IProps> = ({ children }) => {
  return <div className={'w-full px-5 md:px-10 lg:px-16 xl:px-28'}>{children}</div>;
};

interface IProps {
  children: ReactNode;
}
